export default __webpack_public_path__ + "static/media/GoodMannersInARestaurant_13.f77b0f72.png";